export const EMERGENCY_CONTACT_FIELDS = [
  'hasNoEmergencyContact',
  'emergencyContactName', 'emergencyContactRelationship', 'emergencyContactPhone', 'emergencyContactPhone2', 'emergencyContactEmail',
  'emergencyContact2Name', 'emergencyContact2Relationship', 'emergencyContact2Phone', 'emergencyContact2Phone2', 'emergencyContact2Email',
  'additionalEmergencyContact',
] as const;

export const PATIENT_CONTACT_FIELDS = [...EMERGENCY_CONTACT_FIELDS, 'patientEmail'] as const;
export const patientContactField = (field: string) => field === 'patientEmail' ? 'email' : field;

/** Missing patient fields retain assessment history; an explicit blank clears it. */
export function patientContactPopulation(patient: Record<string, unknown>): Record<string, unknown> {
  const output: Record<string, unknown> = {};
  for (const field of PATIENT_CONTACT_FIELDS) {
    const source = patientContactField(field);
    if (Object.prototype.hasOwnProperty.call(patient, source) && patient[source] !== undefined) {
      output[field] = patient[source] ?? (field === 'hasNoEmergencyContact' ? false : '');
    }
  }
  if (!Object.prototype.hasOwnProperty.call(output, 'hasNoEmergencyContact')
    && EMERGENCY_CONTACT_FIELDS.some(field => field !== 'hasNoEmergencyContact' && Boolean(output[field]))) {
    output.hasNoEmergencyContact = false;
  }
  return output;
}

export interface ConsentEmailChoice {
  label: string;
  email: string;
  name?: string;
  phone?: string;
  relationship?: string;
}

export function emergencyContactEmailChoices(data: Record<string, unknown>): ConsentEmailChoice[] {
  if (data.hasNoEmergencyContact === true || String(data.hasNoEmergencyContact).toLowerCase() === 'true') return [];
  return ['emergencyContact', 'emergencyContact2'].flatMap((prefix, index) => {
    const email = String(data[`${prefix}Email`] ?? '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return [];
    const name = String(data[`${prefix}Name`] ?? '').trim();
    return [{
      label: `EC ${index + 1}${name ? ` — ${name}` : ''}: ${email}`,
      email, name,
      phone: String(data[`${prefix}Phone`] || data[`${prefix}Phone2`] || ''),
      relationship: String(data[`${prefix}Relationship`] ?? ''),
    }];
  });
}
